import { JsonObject } from '../../helpers';
import { CreateBaseModel } from '../base.model';
import { CreateTelemetryModel, PatchTelemetryModel, TelemetryModel } from './telemetry.model';
import { object, string } from 'yup';
import DatadogIcon from '@/assets/telemetry-icons/datadog.png';

export type DatadogTelemetryConfig = {
  site: string;
  apiKey: string;
  apiKeyLast4: string;
  ddsource: string;
  ddtags: string | null;
  service: string | null;
  hostname: string | null;
};

export class DatadogTelemetryModel extends TelemetryModel {
  config: DatadogTelemetryConfig;

  constructor(props: JsonObject = {}) {
    super(props);

    const data = props as Record<keyof TelemetryModel, unknown>;

    this.type = 'datadog';
    this.typeLabel = 'Datadog Logs API';
    this.iconImage = DatadogIcon;
    this.config = (data.config as DatadogTelemetryConfig) || {
      site: 'us5',
      apiKey: '',
      apiKeyLast4: '',
      ddsource: 'surepath',
      ddtags: '',
      service: '',
      hostname: '',
    };

    this.schema = this.schema.concat(
      object({
        config: object({
          site: string().required('Site is required'),
          apiKey: string().when('$id', {
            is: (id: string) => !id,
            then: (schema) => schema.required('API Key is required'),
            otherwise: (schema) => schema.notRequired(),
          }),
          ddsource: string().required('Source is required'),
        }),
      })
    );
  }

  get createModel(): CreateBaseModel {
    return new CreateDatadogTelemetryModel(this);
  }

  get patchModel(): CreateBaseModel {
    return new PatchDatadogTelemetryModel(this);
  }
}

class CreateDatadogTelemetryModel extends CreateTelemetryModel {
  config: Partial<DatadogTelemetryConfig>;

  constructor(telemetry: DatadogTelemetryModel) {
    super(telemetry);

    this.type = 'datadog';
    this.config = telemetry.config;

    delete this.connectorId;
    delete this.config.apiKeyLast4;

    if (!this.config.ddtags) {
      delete this.config.ddtags;
    }

    if (!this.config.service) {
      delete this.config.service;
    }

    if (!this.config.hostname) {
      delete this.config.hostname;
    }
  }
}

class PatchDatadogTelemetryModel extends PatchTelemetryModel {
  config: Partial<DatadogTelemetryConfig>;

  constructor(telemetry: DatadogTelemetryModel) {
    super(telemetry);

    this.config = telemetry.config;

    delete this.connectorId;
    delete this.config.apiKeyLast4;

    if (!this.config.apiKey) {
      delete this.config.apiKey;
    }

    if (!this.config.ddsource) {
      delete this.config.ddsource;
    }

    if (!this.config.ddtags) {
      this.config.ddtags = null;
    }

    if (!this.config.service) {
      this.config.service = null;
    }

    if (!this.config.hostname) {
      this.config.hostname = null;
    }
  }
}
